const marketingteam = [
    {
        name: "Enrique Dcosta",
        title: "Marketing",
        imageSrc: "/images/committee/marketing/EnriqueDcosta.jpg",
        socials:{},
    },
    {
        name: "Keyur Parmar",
        title: "Marketing",
        imageSrc: "/images/committee/marketing/Keyur_Parmar.jpg",
        socials: {},
    },
    
    
]

export default marketingteam;